import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as homestayRateAction from '../../../../actions/homestayRateAction';
import HomestayRates from './HomestayRates';
import * as homestayActions from './../../../../actions/homestayAction';

const mapStateToProps = state => {
    return {
        homestayRateState: state.homestayRateReducer,
        homestayState: state.homestayReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListHomestayRates: (filters) => {
            dispatch(homestayRateAction.getListHomestayRates(filters))
        },
        sortHomestayRates: (homestayRates, filters) => dispatch(homestayRateAction.sortHomestayRate(homestayRates, filters)),
        syncHomestayRates: (homestayId, homestayRateCodes, isRefresh, filters) => dispatch(homestayRateAction.syncHomestayRates(homestayId, homestayRateCodes, isRefresh, filters)),
        updateHomestayRateActive: (obj) => dispatch(homestayRateAction.updateHomestayRateActive(obj)),
        usageStatus: (homestayRates, filters) => dispatch(homestayRateAction.usageStatus(homestayRates, filters)),
        syncHomestayRateLanguage: (obj) => dispatch(homestayRateAction.syncHomestayRateLanguage(obj)),
        getHomestayDetail: (id) => dispatch(homestayActions.getHomestayDetail(id)),
        updateHomestayRateExtend: (obj) => dispatch(homestayRateAction.updateHomestayRateExtend(obj))
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(HomestayRates));
